export const globalBranches = ['MOSTL Traveler', 'Non-Ascension Location'];

const branches = {
  AHCMO: [...globalBranches, 'ABS Sterling Heights'],
  ALBIR: [
    ...globalBranches,
    "St. Vincent's Birmingham",
    "St. Vincent's Blount",
    "St. Vincent's Chilton",
    "St. Vincent's East",
    "St. Vincent's St. Clair"
  ],
  ALMOB: [
    ...globalBranches,
    'Non-Hospital Location',
    'Providence Hospital Mobile'
  ],
  AMITA: [
    ...globalBranches,
    'Adventist Bolingbrook',
    'Adventist Glen Oaks',
    'Adventist Hinsdale',
    'Adventist La Grange',
    'Alexian Brothers Behavioral Health',
    'Alexian Brothers Medical Center',
    'Holy Family Medical Center',
    'Mercy Medical Center',
    'Non-Hospital Location',
    'Resurrection Medical Center',
    'St. Alexius Medical Center',
    'St. Elizabeth Hospital Chicago',
    'St. Francis Hospital',
    'St. Joseph Hospital Chicago',
    'St. Joseph Hospital Elgin',
    'St. Joseph Medical Center',
    'St. Mary Hospital Chicago',
    "St. Mary's Hospital Kankakee"
  ],
  DCWAS: [...globalBranches, 'Non-Hospital Location', 'Providence DC'],
  FLJAC: [
    ...globalBranches,
    'Non-Hospital Location',
    "St. Vincent's Clay",
    "St. Vincent's Riverside",
    "St. Vincent's Southside"
  ],
  FLPEN: [
    ...globalBranches,
    'Non-Hospital Location',
    'Sacred Heart Bay Medical',
    'Sacred Heart Emerald Coast',
    'Sacred Heart on the Gulf',
    'Sacred Heart Pensacola',
    'The Haven of our Lady of Peace'
  ],
  INEVA: [
    ...globalBranches,
    'Non-Hospital Location',
    'St. Vincent Evansville',
    'St. Vincent Orthopedic Hospital',
    'St. Vincent Warrick'
  ],
  ININD: [
    ...globalBranches,
    'Non-Hospital Location',
    "Peyton Manning Children's Hospital",
    'St. Vincent Anderson',
    'St. Vincent Carmel',
    'St. Vincent Clay',
    'St. Vincent Dunn ',
    'St. Vincent Fishers',
    'St. Vincent Heart Center',
    'St. Vincent Indianapolis',
    'St. Vincent Jennings',
    'St. Vincent Kokomo',
    'St. Vincent Mercy',
    'St. Vincent Orthopedic Hospital',
    'St. Vincent Randolph',
    'St. Vincent Salem',
    'St. Vincent Seton',
    'St. Vincent Vascular Institute',
    'St. Vincent Stress Center',
    'St. Vincent Williamsport',
    "St. Vincent Women's Hospital",
    'St. Vincent Neighborhood Hospitals '
  ],
  KSWIC: [
    ...globalBranches,
    'Non-Hospital Location',
    'VC Hospital Manhattan',
    'VC Hospital Pittsburg',
    'VC Hospital St. Francis',
    'VC Hospital St. Joseph',
    'VC Hospital St. Teresa',
    'VC Rehabilitation Hospital',
    'Wamego Health Center'
  ],
  MDBAL: [...globalBranches, 'Non-Hospital Location', 'Saint Agnes Hospital '],
  MIDET: [
    ...globalBranches,
    'Madison Heights Oakland',
    'Non-Hospital Location',
    'Novi Providence Park',
    'River District Hospital',
    'Southfield Providence',
    'St. John Moross',
    'Warren Macomb'
  ],
  MIROC: [...globalBranches, 'Non-Hospital Location', 'Rochester Crittenton '],
  MISAG: [
    ...globalBranches,
    'Non-Hospital Location',
    "St. Mary's of MI Saginaw",
    "St. Mary's of MI Standish"
  ],
  MIGRA: [...globalBranches, 'Genesys Medical Center', 'Non-Hospital Location'],
  MIKAL: [
    ...globalBranches,
    'Borgess ',
    'Borgess-Lee',
    'Non-Hospital Location'
  ],
  MITAW: [
    ...globalBranches,
    'Non-Hospital Location',
    'St. Joseph Hospital Tawas'
  ],
  MOSTL: [
    'Non-Ascension Location',
    'Cortex',
    'Edmundson',
    'Westport Center Drive'
  ],
  NYAMS: [...globalBranches, 'Non-Hospital Location', "St. Mary's Hospital"],
  NYBIN: [...globalBranches, 'Non-Hospital Location', 'Our Lady of Lourdes'],
  OKTUL: [
    ...globalBranches,
    'Jane Phillips Bartlesville',
    'Jane Phillips Nowata',
    'Non-Hospital Location',
    'St. John Broken Arrow',
    'St. John Owasso',
    'St. John Sapulpa',
    'St. John Tulsa'
  ],
  TNNAS: [
    ...globalBranches,
    'Dispensary of Hope Distribution Center',
    'Dekalb Hospital',
    'Hickman Hospital',
    'Highlands Hospital',
    'Midtown Hospital',
    'Non-Hospital Location',
    'River Park Hospital',
    'Rutherford Hospital',
    'Stones River Hospital',
    'Three Rivers Hospital',
    'West Hospital'
  ],
  TXAUS: [
    ...globalBranches,
    "Dell Children's Medical Center",
    'Dell Seton Medical Center',
    'Non-Hospital Location',
    'Seton Bastrop',
    'Seton Edgar B. Davis',
    'Seton Hays',
    'Seton Highland Lakes',
    'Seton Medical Center Austin',
    'Seton Northwest',
    'Seton Shoal Creek',
    'Seton Smithville',
    'Seton Southwest',
    'Seton Williamson'
  ],
  TXWAC: [
    ...globalBranches,
    'DePaul',
    'Non-Hospital Location',
    'Providence TX'
  ],
  WIAPP: [
    ...globalBranches,
    'Calumet Hospital',
    'Eagle River Hospital',
    'Good Samaritan Hospital',
    'Howard Young Medical Center',
    'Mercy Medical Center',
    'Non-Hospital Location',
    'Our Lady of Victory',
    'Sacred Heart Hospital',
    "Saint Clare's Hospital",
    "Saint Elizabeth's Wabasha MN",
    "Saint Mary's Hospital",
    "Saint Michael's Hospital",
    'St. Elizabeth Hospital'
  ],
  WIMIL: [
    ...globalBranches,
    'All Saints',
    "Columbia St. Mary's Milwaukee",
    "Columbia St. Mary's Ozaukee",
    'Elmbrook Memorial',
    'Franklin Campus',
    'Non-Hospital Location',
    'Orthopedic Hospital',
    'Sacred Heart Rehabilitation Institute',
    'Saint Francis Hospital',
    'St. Joseph Campus'
  ],
  CHMAR: [...globalBranches, 'Community Health Arkansas'],
  CHMEP: [...globalBranches, 'Community Health El Paso'],
  CHMNO: [...globalBranches, 'Community Health New Orleans'],
  CHMKC: [...globalBranches, 'Community Health Kansas City'],
  CHMSA: [
    ...globalBranches,
    'Central Office',
    "DePaul Children's Center",
    'El Carmen',
    'La Mision',
    'Wesley'
  ],
  'Ascension Living': [
    ...globalBranches,
    'DC - Carroll Manor Nursing Home',
    'FL - St. Catherine Laboure Place',
    'IL-Alexian Village of Elk Grove',
    'IL-Bethlehem Woods Retirement Community',
    'IL-Casa San Carlo Retirement Community',
    'IL-Cor Mariae Center',
    'IL-Fortin Villa Learning Center',
    'IL-Fox Knoll Retirement Community',
    'IL-Heritage Daybreak',
    'IL-Heritage Village',
    'IL-Maryhaven Nursing and Rehabilitation Center',
    'IL-McAuley Manor',
    'IL-Merkle-Knipprath Countryside',
    'IL-Nazarethville',
    'IL-Our Lady of Victory',
    'IL-Pine View Care Center',
    'IL-Resurrection Life Center',
    'IL-Resurrection Nursing and Rehabilitation Center',
    'IL-Resurrection Retirement Community',
    'IL-Saint Anne Center',
    'IL-Saint Benedict Nursing and Rehabilitation Center',
    'IL-Saint Joseph Adult Day Center',
    'IL-Saint Joseph Center',
    'IL-Villa Franciscan',
    'IL-Villa Scalabrini Nursing and Rehabilitation Center',
    'IN-LaVerna Terrace',
    'IN-Sacred Heart Home',
    // 'KS-St. Joseph Place',
    'KS-VC Village Broadmoor',
    'KS-VC Village Georgetown',
    'KS-VC Village Hays',
    'KS-VC Village Manhattan',
    'KS-VC Village McLean',
    'KS-VC Village Pittsburg',
    'KS-VC Village Ponca City',
    'KS-VC Village Ridge',
    'KS-Wichita PACE',
    "MD-St. Joseph's Place",
    'MI-Borgess Place',
    'MI-Genesee PACE',
    'MO-Carondelet Place',
    'MO-Lansdowne Place',
    'MO-Sherbrooke Village',
    "MO-St Mary's Village",
    'Non-Hospital Location',
    'NY-Our Lady of Peace',
    'OK-Via Christi Village',
    'TN-Alexian Brothers Live at Home',
    'TN-Alexian Grove',
    'TN-Alexian PACE',
    'TN-Alexian Village',
    'TN-Valley Residence',
    'TX-Providence Village',
    'WI-Alexian Village',
    'WI-Franciscan Place',
    'WI-Lakeshore at Siena',
    'WI-St. Francis Place',
    'IL-Saint Vincent',
    'WI-AVM Adult Day Care'
  ]
};

export default branches;
